export const IFWStatementsData = [
    {
        state: "ALABAMA",
        value: "AL",
        statement: "§27-12A-20",
        heading:
            "At least one of the following forms: Claim release forms, applications, reinstatements for insurance, participation agreements, declaration pages, and claim documents, regardless of the method or form of transmission:",
        description:
            "Any person who knowingly presents a false or fraudulent claim for payment of a loss or benefit or who knowingly presents false information in an application for insurance is guilty of a crime and may be subject to restitution fines or confinement in prison, or any combination thereof."
    },
    {
        state: "ALASKA",
        value: "AK",
        statement: "§21.36.380",
        heading: "All insurance claim forms:",
        description:
            "A person who knowingly and with intent to injure, defraud, or deceive an insurance company files a claim containing false, incomplete, or misleading information may be prosecuted under state law."
    },
    {
        state: "ARIZONA",
        value: "AZ",
        statement: "§20-466.03",
        heading: "All insurance claim forms:",
        description:
            "For your protection, Arizona law requires the following statement to appear on this form. Any person who knowingly presents a false or fraudulent claim for payment of a loss is subject to criminal and civil penalties."
    },
    {
        state: "ARKANSAS",
        value: "AR",
        statement: "§23-66-503",
        heading:
            "Claim forms, proofs of loss, or any similar documents, however designated, seeking payment or benefit pursuant to an insurance policy, and applications for insurance, regardless of the form of transmission:",
        description:
            "Any person who knowingly presents a false or fraudulent claim for payment of a loss or benefit or knowingly presents false information in an application for insurance is guilty of a crime and may be subject to fines and confinement in prison."
    },
    {
        state: "CALIFORNIA",
        value: "CA",
        statement: ["§1871.2", "§1879.2"],
        heading:
            "All insurance applications, all forms upon which an insured can make changes to an existing policy, and all claim forms:",
        description:
            "For your protection, California law requires the following to appear on this form: Any person who knowingly presents false or fraudulent information to obtain or amend insurance coverage or to make a claim for payment of a loss is guilty of a crime and may be subject to fines and confinement in state prison."
    },
    {
        state: "COLORADO",
        value: "CO",
        statement: "§10-1-128",
        heading: "All insurance applications, or all policy forms, or all claim forms:",
        description:
            "It is unlawful to knowingly provide false, incomplete, or misleading facts or information to an insurance company for the purpose of defrauding or attempting to defraud the company. Penalties may include imprisonment, fines, denial of insurance, and civil damages. Any insurance company or agent of an insurance company who knowingly provides false, incomplete, or misleading facts or information to a policyholder or claimant for the purpose of defrauding or attempting to defraud the policy- holder or claimant with regard to a settlement or award payable from insurance proceeds shall be reported to the Colorado Division of Insurance within the Department of Regulatory Agencies."
    },
    {
        state: "DELAWARE",
        value: "DE",
        statement: "11 §913",
        heading: "All insurance claim forms:",
        description:
            "Any person who knowingly, and with intent to injure, defraud or deceive any insurer, files a statement of claim containing any false, incomplete or misleading information is guilty of a felony."
    },
    {
        state: "DISTRICT OF COLUMBIA",
        value: "DC",
        statement: "§22-3225.09",
        heading: "All insurance applications and claim forms:",
        description:
            "WARNING: It is a crime to provide false or misleading information to an insurer for the purpose of defrauding the insurer or any other person. Penalties include imprisonment and/or fines. In addition, an insurer may deny insurance benefits if false information materially related to a claim was provided by the applicant."
    },
    {
        state: "FLORIDA",
        value: "FL",
        statement: "§817.234",
        heading: "All insurance claim forms:",
        description:
            "All insurance applications and claim forms: Any person who knowingly and with intent to injure, defraud, or deceive any insurer files a statement of claim or an application containing any false, incomplete, or misleading information is guilty of a felony of the third degree."
    },
    {
        state: "IDAHO",
        value: "ID",
        statement: "§41-1331",
        heading: "All insurance claim forms:",
        description:
            "Any person who knowingly, and with intent to defraud or deceive any insurance company, files a statement containing any false, incomplete, or misleading information is guilty of a felony."
    },
    {
        state: "INDIANA",
        value: "IN",
        statement: "§27-2-16-3",
        heading: "All insurance claim forms:",
        description:
            "Any person who knowingly, and with intent to defraud or deceive any insurance company, files a statement containing any false, incomplete, or misleading information is guilty of a felony."
    },
    {
        state: "KENTUCKY",
        value: "KY",
        statement: "§304.47-030",
        heading: ["All insurance claim forms:", "All insurance application forms:"],
        description: [
            "Any person who knowingly and with intent to defraud any insurance company or other person files a statement of claim containing materially false information or conceals, for the purpose of misleading, information concerning any fact material thereto commits a fraudulent insurance act, which is a crime.",
            "Any person who knowingly and with intent to defraud any insurance company or other person files an application for insurance containing any materially false information or conceals, for the purpose of misleading, information concerning any fact material thereto commits a fraudulent insurance act, which is a crime."
        ]
    },
    {
        state: "LOUISIANA",
        value: "LA",
        statement: "§40:1424",
        heading: "All insurance applications and claim forms:",
        description:
            "Any person who knowingly presents a false or fraudulent claim for payment of a loss or benefit or knowingly presents false information in an application for insurance is guilty of a crime and may be subject to fines and confinement in prison."
    },
    {
        state: "MAINE",
        value: "ME",
        statement: "24-A §2186(3) (A)",
        heading: "All insurance applications and claim forms:",
        description:
            "It is a crime to knowingly provide false, incomplete or misleading information to an insurance company for the purpose of defrauding the company. Penalties may include imprisonment, fines or a denial of insurance benefits."
    },
    {
        state: "MARYLAND",
        value: "MD",
        statement: "§27-805",
        heading: "All insurance applications and claim forms:",
        description:
            "Any person who knowingly or willfully presents a false or fraudulent claim for payment of a loss or benefit or who knowingly or willfully presents false information in an application for insurance is guilty of a crime and may be subject to fines and confinement in prison."
    },
    {
        state: "MINNESOTA",
        value: "MN",
        statement: "§60A.955",
        heading: "All insurance claim forms:",
        description:
            "A person who files a claim with intent to defraud or helps commit a fraud against an insurer is guilty of a crime."
    },
    {
        state: "NEW HAMPSHIRE",
        value: "NH",
        statement: "§402:82",
        heading: "All insurance claim forms:",
        description:
            "Any person who, with a purpose to injure, defraud or deceive any insurance company, files a statement of claim containing any false, incomplete or misleading information is subject to prosecution and punishment for insurance fraud, as provided in RSA638:20."
    },
    {
        state: "NEW JERSEY",
        value: "NJ",
        statement: ["§17:33A-6", "NJAC 11:16-1.2"],
        heading: ["All insurance claim forms:", "All insurance application forms:"],
        description: [
            "Any person who knowingly files a statement of claim containing any false or misleading information is subject to criminal and civil penalties.",
            "Any person who includes any false or misleading information on an application for an insurance policy is subject to criminal and civil penalties."
        ]
    },
    {
        state: "NEW MEXICO",
        value: "NM",
        statement: "§59A-16C-8",
        heading: "All insurance applications and claim forms:",
        description:
            "Any person who knowingly presents a false or fraudulent claim for payment of a loss or benefit or knowingly presents false information in an application for insurance is guilty of a crime and may be subject to civil fines and criminal penalties."
    },
    {
        state: "NEW YORK",
        value: "NY",
        statement: ["§403(d) 11 NYCRR", "§86.4"],
        heading: "All insurance applications and claim forms except auto:",
        description:
            "Any person who knowingly and with intent to defraud any insurance company or other person files an application for insurance or statement of claim containing any materially false information, or conceals for the purpose of misleading, information concerning any fact material thereto, commits a fraudulent insurance act, which is a crime, and shall also be subject to a civil penalty not to exceed five thousand dollars and the stated value of the claim for each such violation."
    },
    {
        state: "OHIO",
        value: "OH",
        statement: "§3999.21",
        heading: "All insurance applications and claim forms:",
        description:
            "Any person who, with intent to defraud or knowing that he is facilitating a fraud against an insurer, submits an application or files a claim containing a false or deceptive statement is guilty of insurance fraud."
    },
    {
        state: "OKLAHOMA",
        value: "OK",
        statement: "§3613.1",
        heading: "All insurance applications, policy and claim forms:",
        description:
            "WARNING: Any person who knowingly, and with intent to injure, defraud or deceive any insurer, makes any claim for the proceeds of an insurance policy containing any false, incomplete or misleading information is guilty of a felony.."
    },
    {
        state: "PENNSYLVANIA",
        value: "PA",
        statement: "18 Pa.C.S. § 4117",
        heading: "All insurance applications and claim forms:",
        description:
            "Any person who knowingly and with intent to defraud any insurance company or other person files an application for insurance or statement of claim containing any materially false information or conceals for the purpose of misleading, information concerning any fact material thereto commits a fraudulent insurance act, which is a crime and subjects such person to criminal and civil penalties."
    },
    {
        state: "RHODE ISLAND",
        value: "RI",
        statement: ["§27-29-13.3", "§27-54.1-3"],
        heading: "All insurance applications and claims forms:",
        description:
            "Any person who knowingly presents a false or fraudulent claim for payment of a loss or benefit or knowingly presents false information in an application for insurance is guilty of a crime and may be subject to fines and confinement in prison."
    },
    {
        state: "TENNESSEE",
        value: "TN",
        statement: "§56-53-111",
        heading: "All insurance applications and claim forms:",
        description:
            "It is a crime to knowingly provide false, incomplete or misleading information to an insurance company for the purpose of defrauding the company. Penalties include imprisonment, fines and denial of insurance benefits."
    },
    {
        state: "TEXAS",
        value: "TX",
        statement: "§704.002(a)",
        heading: "All insurance claim forms:",
        description:
            "Any person who knowingly presents a false or fraudulent claim for the payment of a loss is guilty of a crime and may be subject to fines and confinement in state prison."
    },
    {
        state: "VIRGINIA",
        value: "VA",
        statement: "§52-40",
        heading: "All insurance applications and claim forms:",
        description:
            "It is a crime to knowingly provide false, incomplete or misleading information to an insurance company for the purpose of defrauding the company. Penalties include imprisonment, fines and denial of insurance benefits."
    },
    {
        state: "WASHINGTON",
        value: "WA",
        statement: "§48.135.080",
        heading: "All insurance applications and claim forms:",
        description:
            "It is a crime to knowingly provide false, incomplete or misleading information to an insurance company for the purpose of defrauding the company. Penalties include imprisonment, fines and denial of insurance benefits."
    },
    {
        state: "WEST VIRGINIA",
        value: "WV",
        statement: "§33-41-3",
        heading: "All insurance applications and claim forms:",
        description:
            "Any person who knowingly presents a false or fraudulent claim for payment of a loss or benefit or knowingly presents false information in an application for insurance is guilty of a crime and may be subject to fines and confinement in prison."
    }
    // Add more states if needed
]
